import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $CheckoutCustomerDetailsFormModuleName } from "./checkoutCustomerDetailsForm.types";

const isLoading = (state: IState): boolean => {
    return !!getValueState(state, $CheckoutCustomerDetailsFormModuleName)
        ?.isLoading;
};

const getCheckoutCustomerDetailsForm = (state: IState) => {
    return getValueState(state, $CheckoutCustomerDetailsFormModuleName);
};

const deliveryAddressId = (state: IState) => {
    return getCheckoutCustomerDetailsForm(state)?.deliveryAddressId;
};

const paymentAddressId = (state: IState) => {
    return getCheckoutCustomerDetailsForm(state)?.paymentAddressId;
};

export {
    deliveryAddressId,
    getCheckoutCustomerDetailsForm,
    isLoading,
    paymentAddressId
};
